import React from "react"
import { GridColumnProps } from "styled-system"
import { Error, Wrapper } from "../elements"
import * as S from "./elements"

interface Props
  extends React.InputHTMLAttributes<HTMLInputElement>,
    GridColumnProps {
  errorMsg?: string
}

export const Input: React.FC<Props> = ({
  errorMsg,
  value,
  gridColumn,
  ...rest
}) => {
  return (
    <Wrapper gridColumn={gridColumn}>
      <S.InputWrapper>
        <S.StyledInput
          hasError={typeof errorMsg !== "undefined"}
          value={value}
          {...rest}
        />
        {value && !errorMsg && <S.CheckMark />}
        {errorMsg && <S.Error />}
      </S.InputWrapper>
      {errorMsg && <Error>{errorMsg}</Error>}
    </Wrapper>
  )
}
